<div
  [ngClass]="{
    'id-left-cell': placement() === 'LEFT',
    'id-center-cell': placement() === 'CENTER',
    'id-right-cell': placement() === 'RIGHT',
  }">
  <ng-content select="left-from-cbx"></ng-content>
  <input
    class="form-check-input m-0"
    type="checkbox"
    name="row-selector"
    [(ngModel)]="isRowSelected"
    commonSelectSingleRow />
  <ng-content select="right-from-cbx"></ng-content>
</div>
